import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { AssetCardMobile as Card } from '../asset-card/mobile';

import { AssetsCarousel as Component } from './component';
import type { IDepsMobile, TAssetsCarouselMobile } from './models';
import styles from './styles.css';
// eslint-disable-next-line styler/check-styler
export const AssetsCarouselMobile = createWidget<IDepsMobile, TAssetsCarouselMobile>({
    Card,
    styles,
})(Component);
